export enum OrderReceiptTransactionType {
  PURCHASE = 'purchase',
  REFUND = 'refund',
}
